<template>
  <v-autocomplete
    v-model="selectedLocation"
    :items="dropDownLocations"
    item-title="name"
    item-value="name"
    label="Standort"
    density="compact"
    class="dropDownMenu"
    variant="solo"
    hide-details
    attach
  ></v-autocomplete>
</template>

<script>
export default {
  props: {
    modelValue: { type: String, default: '' },
    dropDownLocations: { type: Array, default: () => [] }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      selectedLocation: this.modelValue
    }
  },

  watch: {
    dropDownLocations: {
      handler(val) {
        if (val.length > 0) {
            this.selectedLocation = val[0].name
            this.$emit('update:modelValue', val[0].name)
        }
      },
      deep: true,
      immediate: true
    },

    selectedLocation(val) {
        this.$emit('update:modelValue', val)
    },

    modelValue(val) {
      this.selectedLocation = val
    }
  }
}
</script>

<style scoped>
.v-autocomplete {
  color: black;
  box-shadow: 0px 6px 15px hsla(0, 0%, 0%, 0.5);
  font-size: small;
  border-radius: 4px;
  width: auto;
  min-width: 14rem;
}
</style>
